import type { MetricExpr } from '@redviking/argonaut-util/src/metric-parser/metric-expr';
import { rules } from 'src/util/validator-rules';

/**
 * a validator function that returns an error message as a string, same behavior as {@link import('vuetify2-component-types').InputValidationRule}
 */
type MetricExprRule = (expr: MetricExpr) => boolean | string;

/**
 * utility fn for validating a metric expression for the SparkplugDeviceWrite provider.
 * this exists so the config validation and vuetify rules work the same
 */
export const validateSparkplugDeviceWriteMetricExpr: MetricExprRule = expr => {
    return rules.sparkplugMetricExpr(expr, {
        dataset: false,
        meta: false,
        metric: false,
        propset: false,
        template: false,
    }) || true;
};

export const validateSparkplugMetricExpr: MetricExprRule = expr => {
    return rules.sparkplugMetricExpr(expr, {
        dataset: false,
        meta: true,
        metric: true,
        propset: {
            propset: true,
            propsetlist: true,
        },
        template: false,
    }) || true;
};
